import { render, staticRenderFns } from "./DetailSettingNotification.vue?vue&type=template&id=f703f25c"
import script from "./DetailSettingNotification.vue?vue&type=script&lang=js"
export * from "./DetailSettingNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports